import { Box, Button, Flex, Image, SimpleGrid, Text } from "@chakra-ui/react";
import { apiurl } from "APIURL";
import axios from "axios";
import React from "react";
import { useHistory } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { getCourses, setGlobalCourses } from "redux/slices/coursesSlice";
import {
  selectCurrentCourse,
  setCurrentCourse,
  setIndex,
} from "redux/slices/currentCourseSlice";
import { selectCurrentFormation } from "redux/slices/currentFormationSlice";
import { Course } from "types";

export default function CurrentCourse() {
  const { currCourse, index } = useAppSelector(selectCurrentCourse);

  const dispatch = useAppDispatch();

  const { currFormation } = useAppSelector(selectCurrentFormation);
  const { courses } = useAppSelector(getCourses);

  const navigateToCourse = (e: React.MouseEvent, course: Course) => {
    dispatch(setIndex(index + 1));
    dispatch(setCurrentCourse(course));
    e.preventDefault();
    history.push("/course/get");
  };
  const history = useHistory();
  const readCourse = (e: React.MouseEvent) => {
    e.preventDefault();
    console.log({ currCourse });
    history.push("/course/read");
  };
  React.useEffect(() => {
    const getData = async () => {
      try {
        const res = await axios.get(`${apiurl}/course`);
        dispatch(setGlobalCourses([...res.data]));
      } catch (error) {
        console.log(error);
      }
    };
  }, []);
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <SimpleGrid columns={{ base: 1, md: 2 }} gap="20px">
        <Flex
          direction="column"
          bg={"brand.500"}
          bgSize="cover"
          py={{ base: "30px", md: "56px" }}
          px={{ base: "30px", md: "64px" }}
          borderRadius="30px"
        >
          <Text
            fontSize={{ base: "24px", md: "34px" }}
            color="white"
            mb="14px"
            maxW={{
              base: "100%",
              md: "64%",
              lg: "46%",
              xl: "70%",
              "2xl": "50%",
              "3xl": "42%",
            }}
            fontWeight="700"
            lineHeight={{ base: "32px", md: "42px" }}
          >
            {currCourse.title}
          </Text>
          <Text
            fontSize="md"
            color="white"
            maxW={{
              base: "100%",
              md: "64%",
              lg: "40%",
              xl: "56%",
              "2xl": "46%",
              "3xl": "34%",
            }}
            fontWeight="500"
            mb="40px"
            lineHeight="28px"
          >
            {currCourse.description}
          </Text>
          <Image borderRadius={"30px"} src={currCourse.image} />
          <Flex mt={5} align="center">
            <Button
              onClick={(e) => readCourse(e)}
              bg="white"
              color="black"
              _hover={{ bg: "whiteAlpha.900" }}
              _active={{ bg: "white" }}
              _focus={{ bg: "white" }}
              fontWeight="500"
              fontSize="14px"
              py="20px"
              px="27"
              me="38px"
            >
              Lire
            </Button>
            <Button
              onClick={(e) =>
                navigateToCourse(
                  e,
                  courses.filter(
                    (course) => course.formationId === currFormation.id
                  )[index]
                )
              }
              bg="white"
              color="black"
              _hover={{ bg: "whiteAlpha.900" }}
              _active={{ bg: "white" }}
              _focus={{ bg: "white" }}
              fontWeight="500"
              fontSize="14px"
              py="20px"
              px="27"
              me="38px"
            >
              Cours suivant
            </Button>
          </Flex>
        </Flex>

        {/*<CoursesTable loading={false} tableData={useTableDataCheck().filter(course=>course.formation === currFormation.title)} />*/}
      </SimpleGrid>
    </Box>
  );
}
